import type { BlogPost } from '../../../model';

export type BlogPostSummaryRequest = {
  limit?: number;
};

export type BlogPostSummaryResponse = BlogPost[];
